export default __webpack_public_path__ + "static/media/przelewy24.85d49d56.jpg";